import axios from "axios";
import { iStaffBaseURL } from "src/constants/Urls";
import { notify } from "../../functions/function";

/* Takes placements and returns an array of urgentPlacements, pendingPlacements, assignedPlacements */
export const filterPlacementsIntoStatus = (placements) => {
  const urgentPlacements = placements.filter(
    (p) => !p.is_assigned || !p.employee
  );
  const pendingPlacements = placements.filter(
    (p) => p.is_assigned && p.employee && !p.is_accepted
  );
  const assignedPlacements = placements.filter(
    (p) => p.is_assigned && p.is_accepted
  );

  return [urgentPlacements, pendingPlacements, assignedPlacements];
};

export const removeArrayDups = (arr) => {
  let unique = new Set(arr);
  return [...unique];
};

/* 
Takes an id and removes it from the previous invite list. 
This will allow iStaff to re-add a person to a placement 
*/
export const removePreviousInvite = (
  employeeUserId,
  placement,
  userToken,
  dispatch,
  placements
) => {
  const filteredPrevInvites = removeArrayDups(
    placement.previous_invites.split(",")
  ).filter((id) => {
    return parseInt(id) !== parseInt(employeeUserId);
  });

  let notifyUser = "";
  let success = false;

  axios
    .put(
      iStaffBaseURL + "/handler/placements/",
      [
        {
          ...placement,
          handler: placement.handler ? placement.handler.id : "",
          client: placement.client ? placement.client.id : "",
          employee: placement.employee ? placement.employee.id : null,
          previous_invites: filteredPrevInvites.toString(),
        },
      ],
      {
        headers: { Authorization: "Token " + userToken },
      }
    )
    .then((res) => {
      notifyUser =
        "This user was successfully removed. You can now re add them on DataSavvy and you'll see them here.";
      success = true;
      let updatedPlacements = placements.filter((p) => p.id !== placement.id);
      dispatch({
        type: "UPDATE_INCOMPLETE_PLACEMENTS",
        incompletePlacements: [
          ...updatedPlacements,
          { ...placement, previous_invites: filteredPrevInvites.toString() },
        ],
      });
    })
    .catch((err) => {
      notifyUser = "There was a problem removing this user.";
      success = false;
      console.log(err.response);
    })
    .finally(() => {
      notify("Message", notifyUser, success ? "success" : "danger");
    });
};

export const recipientInArray = (notificationArray, currentPlacement) => {
  return notificationArray.find((n) => {
    if (n.employee && currentPlacement.employee) {
      return n.employee.id === currentPlacement.employee.id;
    }
    return false;
  });
};
